export const COUNTRIES = [
  { code: "SG", name: "Singapore", symbol: "S$", tz: ["Asia/Singapore"] },
  { code: "MY", name: "Malaysia", symbol: "RM", tz: ["Asia/Kuala_Lumpur", "Asia/Kuching"] },
  { code: "ID", name: "Indonesia", symbol: "Rp", tz: ["Asia/Jakarta", "Asia/Makassar", "Asia/Jayapura", "Asia/Pontianak"] },
  { code: "TH", name: "Thailand", symbol: "฿", tz: ["Asia/Bangkok"] },
  { code: "PH", name: "Philippines", symbol: "₱", tz: ["Asia/Manila"] },
  { code: "VN", name: "Vietnam", symbol: "₫", tz: ["Asia/Ho_Chi_Minh", "Asia/Saigon"] },
  { code: "BN", name: "Brunei", symbol: "B$", tz: ["Asia/Brunei"] },
  { code: "KH", name: "Cambodia", symbol: "៛", tz: ["Asia/Phnom_Penh"] },
  { code: "MM", name: "Myanmar", symbol: "K", tz: ["Asia/Yangon", "Asia/Rangoon"] },
  { code: "IN", name: "India", symbol: "₹", tz: ["Asia/Kolkata", "Asia/Calcutta"] },
  { code: "PK", name: "Pakistan", symbol: "Rs", tz: ["Asia/Karachi"] },
  { code: "BD", name: "Bangladesh", symbol: "৳", tz: ["Asia/Dhaka"] },
  { code: "LK", name: "Sri Lanka", symbol: "Rs", tz: ["Asia/Colombo"] },
  { code: "CN", name: "China", symbol: "¥", tz: ["Asia/Shanghai", "Asia/Urumqi"] },
  { code: "HK", name: "Hong Kong", symbol: "HK$", tz: ["Asia/Hong_Kong"] },
  { code: "TW", name: "Taiwan", symbol: "NT$", tz: ["Asia/Taipei"] },
  { code: "JP", name: "Japan", symbol: "¥", tz: ["Asia/Tokyo"] },
  { code: "KR", name: "South Korea", symbol: "₩", tz: ["Asia/Seoul"] },
  { code: "AE", name: "United Arab Emirates", symbol: "AED", tz: ["Asia/Dubai"] },
  { code: "SA", name: "Saudi Arabia", symbol: "SAR", tz: ["Asia/Riyadh"] },
  { code: "AU", name: "Australia", symbol: "A$", tz: ["Australia/"] },
  { code: "NZ", name: "New Zealand", symbol: "NZ$", tz: ["Pacific/Auckland"] },
  { code: "US", name: "United States", symbol: "$", tz: ["America/New_York", "America/Chicago", "America/Denver", "America/Los_Angeles", "America/Phoenix", "America/Anchorage", "Pacific/Honolulu"] },
  { code: "CA", name: "Canada", symbol: "C$", tz: ["America/Toronto", "America/Vancouver", "America/Edmonton", "America/Winnipeg", "America/Halifax"] },
  { code: "MX", name: "Mexico", symbol: "MX$", tz: ["America/Mexico_City"] },
  { code: "BR", name: "Brazil", symbol: "R$", tz: ["America/Sao_Paulo"] },
  { code: "GB", name: "United Kingdom", symbol: "£", tz: ["Europe/London"] },
  { code: "IE", name: "Ireland", symbol: "€", tz: ["Europe/Dublin"] },
  { code: "FR", name: "France", symbol: "€", tz: ["Europe/Paris"] },
  { code: "DE", name: "Germany", symbol: "€", tz: ["Europe/Berlin"] },
  { code: "ES", name: "Spain", symbol: "€", tz: ["Europe/Madrid"] },
  { code: "IT", name: "Italy", symbol: "€", tz: ["Europe/Rome"] },
  { code: "NL", name: "Netherlands", symbol: "€", tz: ["Europe/Amsterdam"] },
  { code: "CH", name: "Switzerland", symbol: "CHF", tz: ["Europe/Zurich"] },
  { code: "SE", name: "Sweden", symbol: "kr", tz: ["Europe/Stockholm"] },
  { code: "ZA", name: "South Africa", symbol: "R", tz: ["Africa/Johannesburg"] },
  { code: "NG", name: "Nigeria", symbol: "₦", tz: ["Africa/Lagos"] },
  { code: "KE", name: "Kenya", symbol: "KSh", tz: ["Africa/Nairobi"] },
];

export const detectCountry = () => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    return COUNTRIES.find((c) => c.tz.some((t) => (t.endsWith("/") ? tz.startsWith(t) : tz === t))) || null;
  } catch {
    return null;
  }
};

export const money = (amount, symbol = "$") => {
  const s = symbol || "$";
  return `${s}${/^[A-Za-z]{2,}$/.test(s) ? " " : ""}${Number(amount).toFixed(2)}`;
};
